module.exports = __webpack_public_path__ + "static/media/logout-icon.28fae9d4.svg";